import { IncognitoType } from '#pplx/frontend/apps/ask/incognito/types.js';
import { useIncognito } from '#pplx/frontend/apps/ask/incognito/useIncognito.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useUserCapabilities } from '#pplx/frontend/apps/ask/queries/user-queries/useUserCapabilities.js';
export const useIsIncognito = ({ reason, }) => {
    const { organization } = useUserOrgData({ reason });
    const { isGovernmentRequestOrigin } = useUserCapabilities();
    const isAlwaysIncognitoRequired = organization?.settings?.always_incognito ?? false;
    const { isIncognitoLocal } = useIncognito();
    const isIncognito = isAlwaysIncognitoRequired || (isIncognitoLocal ?? isGovernmentRequestOrigin ?? false);
    const incognitoType = isGovernmentRequestOrigin
        ? IncognitoType.GOVERNMENT
        : IncognitoType.DEFAULT;
    return {
        isIncognito,
        incognitoType,
        isAlwaysIncognitoRequired,
    };
};
//# sourceMappingURL=useIsIncognito.js.map